export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-18.06036fb8.png";